import React, { Component } from 'react';
import { Button, Grid } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userActions } from '../../state/modules/user';
import { Link } from 'react-router-dom';
import { InputFormField } from '../components';
import { routes } from '../../constants';
import { validateEmail } from '../../services';
import logo from '../../images/logo_rev.svg';

/**
 * Responsible for forgotten password form and actions.
 */
class ForgotPassword extends Component {

  constructor() {
    super();

    this.state = {
      email: '',
      sentEmail: false,
      validation: {
        email: true
      }
    };
  }

  sendResetPasswordEmail(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.validateForm()) {
      this.setState({ sentEmail: true });
      this.props.sendResetPasswordEmail(this.state.email);
    }
  }

  /**
   * Validates the forgotten password form and sets the validation state.
   *
   * Returns true if all fields are valid, false otherwise.
   */
  validateForm() {
    const emailValid = validateEmail(this.state.email);
    this.setState({ validation: { email: emailValid } });
    return emailValid;
  }

  render() {
    let message = this.props.user.error
      ? this.props.user.error.description
      : 'We have sent you a password reset email.';

    return (
      <div className='login'>
        <Grid>
          <form noValidate onSubmit={(e) => this.sendResetPasswordEmail(e)}>
            <header>
              <img src={logo} alt='Caddie Platform' />
              <p>Forgotten password</p>
            </header>
            <main>
              {
                this.state.sentEmail
                  ? (
                    <div style={{ padding: '10px', textAlign: 'center' }}>
                      <span style={{ fontSize: '12px' }}>
                        {message}
                      </span>
                      <br />
                    </div>
                  ) : null
              }
              <p>Enter your email and you will be emailed instructions on how to reset your password:</p>
              <InputFormField id='email' validation={this.state.validation.email ? null : 'Must be a valid email address.'} value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} />
            </main>
            <footer>
              <Button type='submit' className='large'>Reset</Button>
              <p className='center'><small><span><Link to={routes.login}>Back to login</Link></span></small></p>
            </footer>
          </form>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  sendResetPasswordEmail: bindActionCreators(userActions.user.sendResetPasswordEmail, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/containers/pages/forgot-password.js